import { CrudState } from "@/store/Crud/State";

export class ArchiveState extends CrudState {
  archiveSuccess: Record<string, any> = {};
}
